import {useCallback, useEffect} from "react";

// eslint-disable-next-line @typescript-eslint/ban-types
const useOutsideClick = (_node: HTMLElement | null, callback: Function) => {
    const handleClick = useCallback((e: Event) => {
        // @ts-ignore
        if (_node && e.target && !_node.contains(e.target)) {
            callback();
        }
        // eslint-disable-next-line
    }, [_node]);

    useEffect(() => {
        document.addEventListener("click", handleClick);

        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, [_node, handleClick]);
};

export default useOutsideClick;
